import { UnreadType } from './types';

const unreadCountParcer = ({ unread }: UnreadType) => {
  if (!unread) return { unread: 0 };
  return { unread: parseInt(unread, 10) };
};

export default unreadCountParcer;



// WEBPACK FOOTER //
// ./src/services/notifications/utils/unreadCountParser.ts